import RESTSerializer from '@ember-data/serializer/rest';

export default class LicenseSerializer extends RESTSerializer {
  normalize(type, hash, prop) {
    hash.id = 1;
    return super.normalize(type, hash, prop);
  }
}
